export default function ($timeout) {

  return {
    restrict: 'A',
    require: 'ngModel',

    link: function (scope, element) {
      element.on('focus', onFocus);

      function onFocus() {
        //The element has to have focus first, then when the value is changed it will goto the end.
        const currentValue = element.val();
        element.val('');
        $timeout(()=> element.val(currentValue));        
      }
    }
  };
}



// WEBPACK FOOTER //
// ./client/app/common/directives/focusPositionEnd.js